<script lang="ts">
    import { translation } from "../../../../stores.js";
    import Icon from "../../../Icon/Icon.svelte";
    import { closeCall } from "../../../../utils/closeCall.js";
    import { startShareScreen,stopShareScreen } from "../../../../stores/peerConnectionStore.js";
    import { roomStore } from "../../../../stores/roomStore.js";
    import {
        localMediaState,
        localVideoStore,
        muteLocalAudio,
        pauseLocalVideoStream,
        resumeLocalVideoStream,
        unmuteLocalAudio,
    } from "../../../../stores/localVideoStore.js";
    import ScreensharingControls from "./ScreensharingControls.svelte";
    import { pointerStore } from "../../../../stores/pointerStore.js";
    import LocalMediaView from "../LocalMediaView.svelte";
    import IconFa from "../../../Icon/IconFa.svelte";
    import { faWindowRestore } from "@fortawesome/free-solid-svg-icons";
    import { isScreenSharingStore } from "../../../../stores/isScreenSharingStore.js";

    $: room = $roomStore;
    $: pointerPosition = $pointerStore;
    $: mediaState = $localMediaState;

    async function toggleScreenShare() {
        if ($isScreenSharingStore) {
            await stopShareScreen();
        } else {
            await startShareScreen();
        }
    }

    function hangup() {
        closeCall(room.id);
    }
</script>

{#if room}
    <div class="grid grid-cols-6 gap-2 p-4 bg-gray-100 rounded-lg shadow-lg">
        {#if !$isScreenSharingStore}
            <div
                class="col-span-6 flex flex-col items-center justify-center py-12 rounded-lg"
            >
                <Icon
                    name="fa fa-desktop"
                    extraClass="text-gray-400 text-5xl"
                />
                <p class="mt-2 text-gray-500 text-center">
                    {translation.camera.screenSharingDisabled}
                </p>
                <button
                    on:click={toggleScreenShare}
                    class="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 animate-pulse"
                >
                <IconFa icon={faWindowRestore} />
                    {translation.camera.screenSharingButton2}
                </button>
            </div>
        {:else}
            <div class="col-span-6">
                <LocalMediaView
                    stream={$localVideoStore}
                    {mediaState}
                    {pointerPosition}
                    className="local-video"
                />
            </div>
        {/if}

        <div class="col-span-6 flex justify-center space-x-2 py-2">
            <ScreensharingControls
                paused={mediaState.videoPaused}
                muted={mediaState.audioMuted}
                audioEnabled={room.audioEnabled}
                isScreenSharing={$isScreenSharingStore}
                videoPauseOrigin={mediaState.videoPauseOrigin}
                audioMuteOrigin={mediaState.audioMuteOrigin}
                onPause={pauseLocalVideoStream}
                onResume={resumeLocalVideoStream}
                onMute={() => muteLocalAudio("self")}
                onUnmute={() => unmuteLocalAudio("self")}
                onScreenShare={toggleScreenShare}
                onHangup={hangup}
            />
        </div>
    </div>
{/if}
